import React from 'react'
import { format } from 'date-fns'
import * as R from 'ramda'
import Distance from '../../component/Distance'

// Layout stats shown under the hole map: a row of stat cards plus an optional description.
// Course-level location/directions/metadata live in the CourseHeader above this.
function CourseDetails({ course }) {
  const { holes, i1: info, updated } = course

  const par = R.sum(holes.map((hole) => hole.par))
  const distance = Math.round(R.sum(holes.map((hole) => hole.dist)))

  const stats = [
    { label: 'Holes', value: holes.length },
    { label: 'Par', value: par },
    distance > 0 && {
      label: 'Distance',
      value: <Distance distance={distance} />,
    },
    updated && { label: 'Updated', value: format(updated, 'd MMM yyyy') },
  ].filter(Boolean)

  return (
    <div className="course-details">
      <div className="course-details--stats">
        {stats.map((stat, index) => (
          <div className="course-details--stat" key={index}>
            <span className="course-details--stat-value">{stat.value}</span>
            <span className="course-details--stat-label">{stat.label}</span>
          </div>
        ))}
      </div>
      {info && <p className="course-details--description">{info}</p>}
    </div>
  )
}

export default CourseDetails
